import apiClient from './client';

export interface Subject {
  id: string;
  slug: string;
  name: string;
  name_ru: string | null;
  name_kiril: string | null;
  icon: string | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Topic {
  id: string;
  subject_id: string;
  slug: string;
  name: string;
  name_ru: string | null;
  name_kiril: string | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateSubjectDto {
  slug: string;
  name: string;
  name_ru?: string | null;
  name_kiril?: string | null;
  icon?: string | null;
  sort_order?: number;
}

export interface UpdateSubjectDto {
  name?: string;
  name_ru?: string | null;
  name_kiril?: string | null;
  icon?: string | null;
  sort_order?: number;
  is_active?: boolean;
}

export interface CreateTopicDto {
  subject_id: string;
  slug: string;
  name: string;
  name_ru?: string | null;
  name_kiril?: string | null;
  sort_order?: number;
}

export interface UpdateTopicDto {
  name?: string;
  name_ru?: string | null;
  name_kiril?: string | null;
  sort_order?: number;
  is_active?: boolean;
}

export const subjectsApi = {
  getAll: async (): Promise<Subject[]> => {
    const response = await apiClient.get<Subject[]>('/subjects');
    return response.data;
  },

  getById: async (id: string): Promise<Subject> => {
    const response = await apiClient.get<Subject>(`/subjects/${id}`);
    return response.data;
  },

  getTopics: async (subjectId: string): Promise<Topic[]> => {
    const response = await apiClient.get<Topic[]>(`/subjects/${subjectId}/topics`);
    return response.data;
  },

  create: async (dto: CreateSubjectDto): Promise<Subject> => {
    const response = await apiClient.post<Subject>('/admin/subjects', dto);
    return response.data;
  },

  update: async (id: string, dto: UpdateSubjectDto): Promise<Subject> => {
    const response = await apiClient.patch<Subject>(`/admin/subjects/${id}`, dto);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/subjects/${id}`);
  },

  createTopic: async (dto: CreateTopicDto): Promise<Topic> => {
    const response = await apiClient.post<Topic>('/admin/topics', dto);
    return response.data;
  },

  updateTopic: async (id: string, dto: UpdateTopicDto): Promise<Topic> => {
    const response = await apiClient.patch<Topic>(`/admin/topics/${id}`, dto);
    return response.data;
  },

  deleteTopic: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/topics/${id}`);
  },
};
